import { ActiveLink } from '../index';
import styles from './PageTabs.module.scss';

const PageTabs = ({ tabs, pathname = '' }) => {
  const renderTab = (tab, index) => {
    return (
      <div
        className={styles.item}
        key={index}
        itemScope
        itemType='https://schema.org/LinkRole'
      >
        <ActiveLink
          key={index}
          activeClassName={styles.active}
          className={'disabled'}
          href={tab?.href || `/${pathname}/${tab.id}`}
        >
          <a title={tab?.name} aria-label={tab?.name}>
            {tab.name}
          </a>
        </ActiveLink>
      </div>
    );
  };

  return (
    <div
      className={styles.container}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      <div className={'wrapper'}>
        <div className={styles.list}>{tabs?.map(renderTab)}</div>
      </div>
    </div>
  );
};

export default PageTabs;
